import { decode } from 'html-entities'

type TSafeTruncateOptions = {
  removeHtmlTags?: boolean
}

/**
 * Truncates a simple string or a string with HTML. If the string has HTML, the HTML won't be truncated, only the text inside
 * @param string String to be truncated
 * @param maxLength Maximum number of characters (excluding HTML tags) that the string will be truncated to
 * @param options Truncate options
 * @returns Truncated string
 */
function safeTruncate(
  string: string,
  maxLength: number = 150,
  options: TSafeTruncateOptions | undefined = { removeHtmlTags: true },
): string {
  if (string.length <= maxLength) {
    return string
  }

  const withoutHtmlEntites = decode(string)

  // eslint-disable-next-line regexp/no-unused-capturing-group
  const withoutTags = withoutHtmlEntites.replaceAll(/(<([^>]+)>)/g, '')
  if (withoutTags.length <= maxLength) {
    return string
  }

  let truncated = ''

  if (options.removeHtmlTags) {
    truncated = withoutTags.substring(0, maxLength)
  } else {
    let i = 0
    withoutHtmlEntites.split('').forEach((char, index) => {
      if (index - 1 >= maxLength) return
      const currentChar = withoutHtmlEntites.charAt(i)
      if (currentChar === '<') {
        const closingTagIndex = withoutHtmlEntites.indexOf('>', i)
        truncated += withoutHtmlEntites.slice(i, closingTagIndex + 1)
        i = closingTagIndex + 1
      } else {
        truncated += currentChar
        i += 1
      }
    })
  }

  return `${truncated.substring(0, truncated.lastIndexOf(' '))}...`
}

export default safeTruncate
